import type { ComponentRef } from '@wix/editor-platform-sdk-types'
import type { EditorSDK } from '@wix/wix-data-client-common-standalone'

export const openPanelByController = async (
  { editorSdkProxy }: { editorSdkProxy: EditorSDK },
  { controllerRef }: { controllerRef: ComponentRef },
) => {
  const pageRef = await editorSdkProxy.components.getPage({
    componentRef: controllerRef,
  })
  return editorSdkProxy.editor.openPagePanel({ pageRef })
}
